// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3oTKe","row":"Node_row__1dCvZ","label":"Node_label__3CGWs","footer":"Node_footer__2P5Bq"};